module.exports = __webpack_public_path__ + "static/media/home-bg-1.789ec922.jpg";